<app-warning-flags-list>
</app-warning-flags-list>
<user-list-wrapper panelTitle="Tickets" #wrapper [mainService]="service" (onEdit)="editItem($event)"
  [managePerm]="true">
  <app-panel-placeholder *ngIf="(items$|async)?.length == 0 && ((userFlagsService$|async)?.length == 0 || !(userFlagsService$|async|filterOn:['flag', 'isWarning']:[true]).length)" placeholder
    mode="large" image="/assets/images/placeholder-tickets.svg">
  </app-panel-placeholder>
  <app-ticket-list-item *ngFor="let item of (items$|async)" [item]="item"
    (click)="wrapper.edit(item)"></app-ticket-list-item>
</user-list-wrapper>